export type ResolutionUnit = "second" | "minute" | "hour" | "day"

export function resolution(value: number, unit: ResolutionUnit) {
  const second = 1
  const minute = second * 60
  const hour = minute * 60
  const day = hour * 24

  switch (unit) {
    case "second":
      return value * second
    case "minute":
      return value * minute
    case "hour":
      return value * hour
    case "day":
      return value * day
    default:
      return 7 * day
  }
}
